import { ReactNode } from 'react';
import { ModemData } from '../../api/Drone';
import useModemSubscription from './useModemSubscription';

/** Код подписки освобождается при отвязке, а отвязывать можно не чаще раза в месяц. */
function UnbindNotice({ drone }: { drone: ModemData }): ReactNode {
    const subscriptionInfo = useModemSubscription(drone);

    return (
        <>
            <div>Отвязывать устройство можно не чаще чем раз в месяц</div>
            {subscriptionInfo?.unbindAvailable ? (
                <div>Сохраните код для повторного использования: <span className='bold-text'>{subscriptionInfo?.code}</span></div>
            ) : (
                <div>Отвязать устройство станет доступно: {subscriptionInfo?.unbindAvailableTime}</div>
            )}
        </>
    );
}

export default UnbindNotice;
